'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reactGoogleLogin = require('react-google-login');

var _reactGoogleLogin2 = _interopRequireDefault(_reactGoogleLogin);

var _FirebaseAuth = require('helpers/FirebaseAuth');

var _FirebaseAuth2 = _interopRequireDefault(_FirebaseAuth);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {
//   FormGroup,
//   // ControlLabel,
//   InputGroup,
//   FormControl,
//   } from 'react-bootstrap';
// import { Link } from 'react-router';
var Login = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    loginError: state.auth.loginError
  };
}, authActions), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Login);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inputs: {
        email: '',
        password: '',
        save: false,
        errorMsg: ''
      },
      emailValidate: true,
      passwordValidate: true
    }, _this.onChangeEmail = function (event) {
      var emailValidate = false;
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.target.value) || event.target.value === '') {
        emailValidate = true;
      }
      var inputs = _this.state.inputs;
      inputs.email = event.target.value;
      _this.setState({
        inputs: inputs,
        emailValidate: emailValidate
      });
    }, _this.onChangePassword = function (event) {
      var passwordValidate = false;
      if (event.target.value.length >= 8 || event.target.value === '') {
        passwordValidate = true;
      }
      var inputs = _this.state.inputs;
      inputs.password = event.target.value;
      _this.setState({
        inputs: inputs,
        passwordValidate: passwordValidate
      });
    }, _this.handleSubmit = function (event) {
      event.preventDefault();
      var emailValidate = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(_this.email.value);
      var passwordValidate = _this.password.value.length >= 8;
      if (emailValidate && passwordValidate) {
        _this.state.inputs.save = _this.refs.save.checked;
        _this.props.login(_this.state.inputs);
      } else {
        _this.setState({
          emailValidate: emailValidate,
          passwordValidate: passwordValidate
        });
      }
    }, _this.loginFacebook = function () {
      window.FB.login();
    }, _this.responseGoogleSuccess = function (response) {
      _this.props.loginGoogle(response.accessToken);
    }, _this.responseGoogleFailure = function (response) {
      if (response.error === 'access_denied') {
        _this.setState({ errorMsg: 'Vui lòng cấp quyền cho app' });
      } else if (response.error === 'immediate_failed') {
        _this.setState({ errorMsg: 'Đã xảy ra lỗi. Vui lòng thử lại' });
      }
    }, _this.responsePhone = function (response) {
      _this.props.loginPhone(response);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Login, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Login.scss');
      // const { loginError } = this.props;
      // const { emailValidate, passwordValidate, inputs } = this.state;
      return _react2.default.createElement(
        'div',
        { className: styles.loginPage + ' container' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Login' }),
        _react2.default.createElement(
          'div',
          { className: styles.loginContent },
          _react2.default.createElement(
            'div',
            { className: styles.leftContent },
            _react2.default.createElement(
              'div',
              { className: styles.headerLogin },
              '\u0110\u0103ng Nh\u1EADp'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.social },
              _react2.default.createElement(
                'button',
                {
                  className: styles.facebook,
                  onClick: function onClick() {
                    return _this2.loginFacebook();
                  }
                },
                _react2.default.createElement('i', {
                  className: 'fa fa-facebook ' + styles.icon,
                  'aria-hidden': 'true'
                }),
                _react2.default.createElement(
                  'span',
                  { className: styles.socialLabel },
                  'Facebook'
                )
              ),
              _react2.default.createElement(_reactGoogleLogin2.default, {
                autoLoad: false,
                clientId: _config2.default.googleId,
                onSuccess: this.responseGoogleSuccess.bind(this),
                onFailure: this.responseGoogleFailure.bind(this),
                render: function render(renderProps) {
                  return _react2.default.createElement(
                    'button',
                    {
                      className: styles.google,
                      onClick: renderProps.onClick
                    },
                    _react2.default.createElement('i', { className: 'fa fa-google ' + styles.icon }),
                    _react2.default.createElement(
                      'span',
                      null,
                      'Google'
                    )
                  );
                }
              })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _FirebaseAuth2.default,
                { desktopMode: true, onResponse: this.responsePhone },
                function (p) {
                  return _react2.default.createElement(
                    'button',
                    (0, _extends3.default)({}, p, { className: styles.phone }),
                    _react2.default.createElement('i', {
                      className: 'fa fa-phone ' + styles.icon,
                      'aria-hidden': 'true'
                    }),
                    'Login with Phone Number'
                  );
                }
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.register },
              _react2.default.createElement(
                'div',
                null,
                'Ch\u01B0a c\xF3 t\xE0i kho\u1EA3n ',
                _react2.default.createElement(
                  'strong',
                  null,
                  'Lookme'
                ),
                '?',
                ' ',
                _react2.default.createElement(
                  'span',
                  { className: styles.registerSpan },
                  _react2.default.createElement(
                    _FirebaseAuth2.default,
                    { desktopMode: true, onResponse: this.responsePhone },
                    function (p) {
                      return _react2.default.createElement(
                        'div',
                        p,
                        ' \u0110\u0103ng k\xFD ngay'
                      );
                    }
                  )
                )
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.rightContent })
        )
      );
    }
  }]);
  return Login;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  loginError: _react.PropTypes.object,
  login: _react.PropTypes.func,
  logout: _react.PropTypes.func,
  loginPhone: _react.PropTypes.func,
  loginGoogle: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = Login;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/Login.js
// module id = 1678
// module chunks = 0